export default function prettyDate(): string {
  const today = new Date();
  const day = today.getDate() >= 10 ? today.getDate() : `0${today.getDate()}`;
  const month =
    today.getMonth() >= 9 ? today.getMonth() + 1 : `0${today.getMonth() + 1}`;
  const year = today.getFullYear();

  return `${day}/${month}/${year}`;
}
